export default {
    new_migration_account: 'Account',
    new_migration_server: 'Server',
    new_migration_account_name: 'Account Name',
    new_migration_no_data_available: 'No data available',
    new_migration_entity_to_migrate: 'Entity to Migrate',
    new_migration_contacts: 'Contacts',
    new_migration_categories: 'Categories',
    new_migration_behavior: 'Behavior',
    new_migration_users: 'Users',
    new_migration_drivers: 'Drivers',
    new_migration_devices: 'Devices',
    new_migration_geofences: 'Geofences',
    new_migration_maintenance: 'Maintenance',
    new_migration_import: 'Import',
    new_migration_import_from_p4: 'Import From P4',
    new_migration_records_found: 'Records Found',
    MigrationExists: "Migration Exists",
    MigrationNotExists: "Migration Not Exists",
    new_migration_success_message: "Migration started to be executed",
    new_migration_error_message: "Unable to run the migration due to an error",
    new_migration_warning_message: "It is necessary to verify that the name of the selected P4 and PX accounts match",
    new_migration_account_registered: "There is already an account registered under the name of",
    new_migration_in_px: "in PX",
    new_migration_verify_accounts: "It is necessary to verify that the name of the selected P4 and PX accounts match",
    new_migration_pair_with_this_px: "Pair With This PX Account",
    new_migration_alerts: "Alerts",
    new_migration_speed_override: "Speed Override",
    new_migration_entities: "Entities",
}

